import React from 'react'
import './styles/SliderWrapper.scss'

const SliderWrapper = ({ children }) => (
  <div className="slider-wrapper">
    {children}
  </div>
);

export default SliderWrapper;
